import { render, staticRenderFns } from "./userProtocol.vue?vue&type=template&id=3a50f349&scoped=true"
import script from "./userProtocol.vue?vue&type=script&lang=js"
export * from "./userProtocol.vue?vue&type=script&lang=js"
import style0 from "./userProtocol.vue?vue&type=style&index=0&id=3a50f349&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50f349",
  null
  
)

export default component.exports